


























import G01ItemListGroupHeader from "@/general/components/pages/parts/Ranking/G01ItemListGroupHeader.vue";
import G01ItemList from "@/general/components/pages/parts/Ranking/G01ItemList.vue";
import G01ItemCarousel from "@/general/components/pages/parts/Ranking/G01ItemCarousel.vue";
import { Prop, Vue, Component } from "vue-property-decorator";
import globals from "@/general/store/modules/globals";

@Component({
  components: {
    G01ItemListGroupHeader,
    G01ItemList,
    G01ItemCarousel
  }
})
export default class G01ItemListGroup extends Vue {
  @Prop({ type: String, required: true, default: "" }) categoryId!: string;
  @Prop({ type: String, required: true, default: "" }) categoryLabel!: string;
  @Prop({ type: Array, required: true, default: () => [] }) items!: any;
  @Prop({ type: Boolean, required: true, default: true }) isCategory!: boolean;
  @Prop({ type: Boolean, required: false, default: false }) isFirst!: boolean;

  get isSp() {
    return globals?.isLargeBreakpointWidthOfSp;
  }
}
